export default __webpack_public_path__ + "images/79cc1cbc7e00a7b5be0f0d4f5013aec0.png";